import { useAuthApi } from './useAuthApi';
import { useAuthGetters } from './useAuthGetters';
import { useAuthHelpers } from './useAuthHelpers';

import type { UseDjustAuth } from './types';
export function useDjustAuth(): UseDjustAuth {
  return {
    ...useAuthApi(),
    ...useAuthGetters(),
    ...useAuthHelpers(),
  };
}
